export const addFetus = {
	examiner_id: "",
	datetime: "",
	dilation: "",
	delee_plan: "",
	heart_rate: "",
	contractions_per_second: [""] as Array<string | null>,
	amniotic_sac: "",
	amniotic_fluid: "",
	medication_taken: "",
	product_id: "",
	systolic_blood_pressure: "",
	diastolic_blood_pressure: "",
	pulse: "",
	temperature: "",
	observations: "",

	examiner_label: "",
	product_label: "",
};
